import { ControlListProps, useTranslations } from "@bsm/component";
import _ from "lodash";

export const usePublicHolidayCreateForm = (id?: number): ControlListProps => {
    const [
        TITLE_CREATE,
        TITLE_EDIT,
        HOLIDAY_NAME,
        START_DATE,
        COMMENT,
        SAVE,
        CANCEL,
    ] = useTranslations(i18n);

    return {
        data: {
            title: id ? TITLE_EDIT : TITLE_CREATE,
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "hidden",
                    name: "year",
                    defaultValue: new Date().getFullYear().toString(),
                },
                {
                    type: "text",
                    name: "name",
                    label: HOLIDAY_NAME,
                    required: true,
                },
                {
                    type: "date",
                    name: "startDate",
                    label: START_DATE,
                    required: true,
                },
                {
                    type: "textarea",
                    name: "comment",
                    label: COMMENT,
                },
            ],
            hideBack: true,
            next: {
                label: SAVE,
                endIcon: "fas fa-save",
            },
            back: {
                label: CANCEL,
                startIcon: "fas fa-times",
            },
            graphQL: {
                entity: "holiday",
                entityId: id,
            },
        },
        onBeforeSaving: (value) => {
            const value_ = _.clone(value);
            if (!id) {
                value_.holidayType = 'VARIABLE_HOLIDAY';
                value_.endDate = value_.startDate;
                value_.year = new Date().getFullYear().toString();
                value_.isPaid = true;
            }
            return value_;
        }
    };
};

const i18n = [
    "BSMRH.PublicHoliday.Create.Title",
    "BSMRH.PublicHoliday.Edit.Title", 
    "BSMRH.PublicHoliday.Form.Name.Label",
    "std_date",
    "std_comment",
    "std_save",
    "std_cancel",
];